module.exports = __webpack_public_path__ + "static/media/study 201029.cf35ad10.png";